import React, { useState } from 'react';
//internal and external components import
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { TableRow, Checkbox, Chip, TextField, ThemeProvider, createTheme, Tooltip, Typography,InputAdornment, Button  } from '@mui/material';
import { stableSort, getComparator } from '../../common/SortSupport';
import { EnhancedTableHead } from '../EnhancedTableHead';
import { Box } from '@mui/material';
import ActionDetailPopper from '../../containers/ActionDetailPopper';
import { accountingProfitLoss } from '../../assets/staticData';
import YenTextField from '../YenTextField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faCheck, faTrash, faPlus } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setProfitAndLossDetails, setIsUpdatedProfitAndLoss } from '../../redux/reducers/dataCaptures';
import { deleteProfitAndLoss } from '../../api/dataCapture';
import { relative } from 'path';
import { isEmpty } from '../../common/StaticExports';

const theme = createTheme({
  components: {
    MuiStack: {
      styleOverrides: {
        root: {
          display: 'inline',
          width: '90px'
        }
      }
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          minWidth: '90px !important',
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          fontSize: 12
        }
      }
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          width: 18,
          height: 18
        }
      }
    }
  },
})

const AccountingProfitLossTable = () => {

  //supporting contents
  const [order, setOrder] = React.useState('');
  const [orderBy, setOrderBy] = React.useState('');
  const [openActionDetail, setOpenActionDetail] = React.useState(false);
  const [isAPTIrow, setAPTIrow] = useState(false);
  const [isAPTErow, setAPTErow] = useState(false);
  const data = useSelector((state:any) => state.dataCaptures.profitAndLossDetails);
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const [newDataI, setNewDataI]:any = useState({});
  const [newDataE, setNewDataE]:any = useState({});
  const currentClub = useSelector((state:any) => state.clubDetails);
  const isAdmin = useSelector((state:any) => state.common.isAdmin);

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any,
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const visibleRows = React.useMemo(
    () =>
      data?.length > 0 &&
      stableSort(data, getComparator(order, orderBy)),
    [order, orderBy, data],
  );

  const head = [
    {
        key: '', displayName: t('DC_3_LINE_ITEM'),
    },
    {
        key: '', displayName: t('DC_3_SUB_LINE_ITEM'),
    },
    {
        key: '', displayName: `${data[0]?.year - 1} ${t('DC_3_FIGURE')}`,
    },
    {
        key: '', displayName: `${data[0]?.year} ${t('DC_3_BUDGET')}`,
    },
    {
      key: '', displayName: '',
  },
  ]
  
  const updateState = ((updatedRow:any) => {
    const updatedList = data?.map((item:any) => ((item?.id !== null && item?.id == updatedRow?.id) || item?.tempId == updatedRow?.tempId) ? updatedRow : item);
    dispatch(setProfitAndLossDetails(updatedList));
    const boolean:any = true;
    dispatch(setIsUpdatedProfitAndLoss(boolean));
  });

  const manageCreatenew = (from:any) => {
    const tempObj = from == 'Income' ? newDataI : newDataE;
    const tempData = {...tempObj, name: 'Other', tempId: Math.random(), mandatory: false, type: from}
    const updatedList:any = [...data, tempData];
    dispatch(setProfitAndLossDetails(updatedList));
    const boolean:any = true;
    dispatch(setIsUpdatedProfitAndLoss(boolean));
    from == 'Income' ? setNewDataI({}) : setNewDataE({});
    from == 'Income' ? setAPTIrow(false) : setAPTErow(false);
  }

  const manageDeleteRow = (row: any) => {
    let updatedList:any = [];
    if(row?.id) {
      deleteProfitAndLoss({ clubId: currentClub.id, id: row?.id });
      updatedList = data?.filter((d:any) => d?.id != row?.id);
    } else {
     updatedList = data?.filter((d:any) => d?.tempId != row?.tempId);
    }
    dispatch(setProfitAndLossDetails(updatedList));
    const boolean:any = true;
    dispatch(setIsUpdatedProfitAndLoss(boolean));
  }

  //table contents
    return(
        <React.Fragment>
          <ThemeProvider theme={theme}>
          <Box sx={{ position: 'relative' }}>
              <ActionDetailPopper isOpen={openActionDetail} handleIsOpen={() => {setOpenActionDetail(false)}} />
              <TableContainer>
                <Table stickyHeader size="small" aria-label="a dense table">
                    <EnhancedTableHead
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                    tableHeads={head}
                    bg={'#FAFAFA'}
                    />
                    {/* tital table here */}
                    <TableBody>
                      <TableRow
                        key={`accountingpl-table-row-Total`}
                        >
                        <TableCell className='fs12 textAlignLeft fw700' colSpan={5}>
                            {t('DC_3_CLUB_TOTAL').toUpperCase()}
                        </TableCell>
                        </TableRow>
                        {
                          data && data?.filter((d:any) => d.type == 'Total')?.length > 0 &&
                          data?.filter((d:any) => d.type == 'Total')?.map((d: any, i: number) => (
                            <>
                                <TableRow
                                sx={{ cursor: 'pointer' }}
                                key={`accountingpl-table-row-${i}`}
                                >
                                    <TableCell className='fs12'>
                                        {d.name}
                                    </TableCell>
                                    <TableCell className='fs12'>
                                        {d.otherExpenseName}
                                    </TableCell>
                                    <TableCell className='fs12'>
                                        <YenTextField v={d.currentYear} manageChange={(e:any) => {updateState({ ...d, currentYear: e})}} isError={isEmpty(d.currentYear)} errorMessage={t('REQUIRED')} isReadOnly={isAdmin}/>
                                    </TableCell>
                                    <TableCell className='fs12'>
                                        <YenTextField v={d.nextYear} manageChange={(e:any) => {updateState({ ...d, nextYear: e})}} isError={isEmpty(d.nextYear)} errorMessage={t('REQUIRED')} isReadOnly={isAdmin}/>
                                    </TableCell>
                                    <TableCell>
                                    </TableCell>
                                </TableRow>
                            </>
                          ))
                        }
                    </TableBody>
                    {/* Income Table here */}
                    <TableBody>
                      <TableRow
                        key={`accountingpl-table-row-Income`}
                        >
                        <TableCell className='fs12 textAlignLeft fw700' colSpan={5}>
                            {t('DC_3_INCOME').toUpperCase()}
                        </TableCell>
                        </TableRow>
                        {
                          data && data?.filter((d:any) => d.type == 'Income')?.length > 0 &&
                          data?.filter((d:any) => d.type == 'Income')?.map((d: any, i: number) => (
                            <>
                                <TableRow
                                sx={{ cursor: 'pointer' }}
                                key={`accountingpl-table-row-${i}`}
                                >
                                    <TableCell className='fs12'>
                                        {d.name}
                                    </TableCell>
                                    <TableCell className='fs12'>
                                        {d.otherExpenseName}
                                    </TableCell>
                                    <TableCell className='fs12'>
                                        <YenTextField v={d.currentYear} manageChange={(e:any) => {updateState({ ...d, currentYear: e})}} isError={isEmpty(d.currentYear)} errorMessage={t('REQUIRED')} isReadOnly={isAdmin} />
                                    </TableCell>
                                    <TableCell className='fs12'>
                                        <YenTextField v={d.nextYear} manageChange={(e:any) => {updateState({ ...d, nextYear: e})}} isError={isEmpty(d.nextYear)} errorMessage={t('REQUIRED')} isReadOnly={isAdmin} />
                                    </TableCell>
                                    <TableCell>
                                      {
                                        !isAdmin &&
                                        !d?.mandatory &&
                                        <Tooltip title='Delete' arrow placement='top'>
                                          <FontAwesomeIcon 
                                          onClick={() => {manageDeleteRow(d)}} 
                                          className={'icon mr10 deleteIcon'} 
                                          icon={faTrash}/>
                                        </Tooltip>
                                      }
                                    </TableCell>
                                </TableRow>
                            </>
                          ))
                        }
                      {
                        !isAdmin &&
                        isAPTIrow &&
                        <TableRow
                        sx={{ cursor: 'pointer' }}
                        key={`accountingpl-table-add-row-`}
                        >
                            <TableCell className='fs12'>
                              Other
                            </TableCell>
                            <TableCell className='fs12'>
                                <TextField 
                                variant='standard'
                                disabled={isAdmin}
                                value={newDataI?.otherExpenseName}
                                onChange={(e:any) => {setNewDataI({ ...newDataI, otherExpenseName: e.target.value})}}
                                error={isEmpty(newDataI?.otherExpenseName)} helperText={isEmpty(newDataI?.otherExpenseName) ? t('REQUIRED') : ''}/>
                            </TableCell>
                            <TableCell className='fs12'>
                                <YenTextField v={newDataI?.currentYear} manageChange={(e:any) => {setNewDataI({ ...newDataI, currentYear: e})}} isError={isEmpty(newDataI?.currentYear)} errorMessage={t('REQUIRED')} isReadOnly={isAdmin} />
                            </TableCell>
                            <TableCell className='fs12'>
                                <YenTextField v={newDataI?.nextYear} manageChange={(e:any) => {setNewDataI({ ...newDataI, nextYear: e})}} isError={isEmpty(newDataI?.nextYear)} errorMessage={t('REQUIRED')} isReadOnly={isAdmin} />
                            </TableCell>
                            <TableCell>
                              <Tooltip title='Delete' arrow placement='top'>
                                <FontAwesomeIcon onClick={() => {setNewDataI({}); setAPTIrow(false)}} className={'icon mr10'} icon={faXmark}/>
                              </Tooltip>
                              <Tooltip title='Create' arrow placement='top'>
                                <FontAwesomeIcon className={'icon mr10'} icon={faCheck} onClick={() => {manageCreatenew('Income')}}/>
                              </Tooltip>
                            </TableCell>
                        </TableRow>
                      }
                    </TableBody>
                    {
                      !isAdmin &&
                      <Button className='smallButton' 
                      sx={{ mt: '10px', position: 'relative', left: '1010px' }} 
                      disableElevation disabled={isAPTIrow} 
                      variant='contained' size='small' 
                      onClick={() => setAPTIrow(true)} startIcon={<FontAwesomeIcon icon={faPlus} />}>
                          {'Add other expense'}
                      </Button>
                    }
                    {/* expense table here */}
                    <TableBody>
                      <TableRow
                      key={`accountingpl-table-row-Expense`}>
                          <TableCell className='fs12 textAlignLeft fw700' colSpan={5}>
                              {t('DC_3_EXPENSE').toUpperCase()}
                          </TableCell>
                      </TableRow>
                        {
                          data && data?.filter((d:any) => d.type == 'Expense')?.length > 0 &&
                          data?.filter((d:any) => d.type == 'Expense')?.map((d: any, i: number) => (
                            <>
                                <TableRow
                                sx={{ cursor: 'pointer' }}
                                key={`accountingpl-table-row-${i}`}
                                >
                                    <TableCell className='fs12'>
                                        {d.name}
                                    </TableCell>
                                    <TableCell className='fs12'>
                                        {d.otherExpenseName}
                                    </TableCell>
                                    <TableCell className='fs12'>
                                        <YenTextField v={d.currentYear} manageChange={(e:any) => {updateState({ ...d, currentYear: e})}} isError={isEmpty(d.currentYear)} errorMessage={t('REQUIRED')} isReadOnly={isAdmin} />
                                    </TableCell>
                                    <TableCell className='fs12'>
                                        <YenTextField v={d.nextYear} manageChange={(e:any) => {updateState({ ...d, nextYear: e})}} isError={isEmpty(d.nextYear)} errorMessage={t('REQUIRED')} isReadOnly={isAdmin} />
                                    </TableCell>
                                    <TableCell>
                                      {
                                        !isAdmin &&
                                        !d?.mandatory &&
                                        <Tooltip title='Delete' arrow placement='top'>
                                          <FontAwesomeIcon 
                                          onClick={() => {manageDeleteRow(d)}} 
                                          className={'icon mr10 deleteIcon'} 
                                          icon={faTrash}/>
                                        </Tooltip>
                                      }
                                    </TableCell>
                                </TableRow>
                            </>
                          ))
                        }
                      {
                        !isAdmin &&
                        isAPTErow &&
                        <TableRow
                        sx={{ cursor: 'pointer' }}
                        key={`accountingpl-table-add-row-`}
                        >
                            <TableCell className='fs12'>
                              Other
                            </TableCell>
                            <TableCell className='fs12'>
                                <TextField 
                                variant='standard'
                                disabled={isAdmin}
                                value={newDataE?.otherExpenseName}
                                onChange={(e:any) => {setNewDataE({ ...newDataE, otherExpenseName: e.target.value})}}  error={isEmpty(newDataE?.otherExpenseName)} helperText={isEmpty(newDataE?.otherExpenseName) ? t('REQUIRED') : ''} />
                            </TableCell>
                            <TableCell className='fs12'>
                                <YenTextField v={newDataE?.currentYear} manageChange={(e:any) => {setNewDataE({ ...newDataE, currentYear: e})}} isError={isEmpty(newDataE?.currentYear)} errorMessage={t('REQUIRED')} isReadOnly={isAdmin} />
                            </TableCell>
                            <TableCell className='fs12'>
                                <YenTextField v={newDataE?.nextYear} manageChange={(e:any) => {setNewDataE({ ...newDataE, nextYear: e})}} isError={isEmpty(newDataE?.nextYear)} errorMessage={t('REQUIRED')} isReadOnly={isAdmin} />
                            </TableCell>
                            <TableCell>
                              <Tooltip title='Delete' arrow placement='top'>
                                <FontAwesomeIcon onClick={() => {setNewDataE({}); setAPTErow(false);}} className={'icon mr10'} icon={faXmark}/>
                              </Tooltip>
                              <Tooltip title='Create' arrow placement='top'>
                                <FontAwesomeIcon className={'icon mr10'} icon={faCheck} onClick={() => {manageCreatenew('Expense')}}/>
                              </Tooltip>
                            </TableCell>
                        </TableRow>
                      }
                    </TableBody>
                    {
                      !isAdmin &&
                      <Button className='smallButton' 
                      sx={{ mt: '10px', position: 'relative', left: '1010px' }} 
                      disableElevation disabled={isAPTErow} 
                      variant='contained' size='small' 
                      onClick={() => setAPTErow(true)} startIcon={<FontAwesomeIcon icon={faPlus} />}>
                          {'Add other expense'}
                      </Button>
                    }
                </Table>
              </TableContainer>
            </Box>
          </ThemeProvider>
        </React.Fragment>
    )
}

export default AccountingProfitLossTable;